import { cn } from "@layer/utils/cn";
import type * as React from "react";

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
	return (
		<input
			type={type}
			data-slot="input"
			className={cn(
				"placeholder:text-app-text-subtle selection:bg-app-brand/20 selection:text-app-text border-input-border h-9 w-full min-w-0 rounded-md border bg-input-bg/30 px-3 py-1 text-base transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
				"focus-visible:border-[var(--input-border-focus)] focus-visible:shadow-[var(--input-shadow-focus)]",
				"aria-invalid:border-danger-border",
				className,
			)}
			{...props}
		/>
	);
}

export { Input };
